import { type Permission } from '@common/api/permission';
import type { RetailerLevel } from '@common/types/api';
import { type GUID } from '@common/types/brandedTypes';

export enum UserLevel {
  User = 10,
  AdvancedUser = 20,
  EnergyProvider = 28,
  RetailerAdmin = 30,
  Technician = 35,
  Developer = 38,
  CountryManager = 40,
  SuperAdmin = 50,
}

export interface ServiceConsentState {
  consented: boolean;
  createdUtc: string;
}

export interface ServiceConsentsResponse {
  customerContact?: ServiceConsentState;
  installerCommunication?: ServiceConsentState;
}

export interface UserAgreementsResponse {
  serviceConsents?: ServiceConsentsResponse;
}

export interface UserData {
  id: GUID;
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  culture: string;
  countryCode: string;
  timeZone: string;
  phoneNumber: string;
  hasAcceptedEula: boolean;
  levelId: UserLevel;
  countryAccesses?: Array<string>;
  deactivatedUtc?: string;
  retailers?: Array<{
    id: string;
    name: string;
    levelId: UserLevel;
    retailerLevel: RetailerLevel;
  }>;
  lastLoginUtc?: string;
  permissions?: Permission[];
  lastEmailChangeVerification?: {
    email?: string;
    createdUtc?: string;
  };
  agreements?: UserAgreementsResponse;
}

export interface CurrentUserUpdateRequest {
  newEmail?: string;
  oldPassword?: string;
  newPassword?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  culture?: string;
  timeZone?: string;
  phoneNumber?: string;
  emailConfirmationUrl?: string;
  hasAcceptedEula?: true;
}

export interface GetUsersQuery {
  limit: number;
  offset: number;
  sort?: string;
  filter?: string;
  partnerIds?: Array<string>;
  levels?: Array<UserLevel>;
  countryAccesses?: Array<string>;
  isDeactivated?: boolean;
}

export interface PostUserQuery {
  email: string;
  firstName: string;
  lastName: string;
  culture: string;
  timeZone: string;
  phoneNumber: string;
  levelId: number;
  countryCode: string;
  userCountryAccesses: Array<string>;
  retailers?: [{ id: string; levelId: number; }];
  permissions?: Permission[];
}

export interface PutUserQuery {
  firstName: string;
  lastName: string;
  culture: string;
  countryCode: string;
  timeZone: string;
  phoneNumber: string;
  levelId: UserLevel;
  email: string;
}

export interface UserAccessResponse {
  isOwner: boolean;
  levelId: UserLevel;
  user: {
    id: GUID;
    email: string;
    firstName: string;
    lastName: string;
    levelId: UserLevel;
  };
}

export interface AlexaLoginRequest {
  oauthRequestId: string;
  userName: string;
  password: string;
}
